/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 9999eb1d882990f19e352fba26b6c3f62977c8a7
 */

/**
 * Profile role enumeration for user access within an account.
 */
export type ProfileRole = typeof ProfileRole[keyof typeof ProfileRole];


export const ProfileRole = {
  owner: 'owner',
  admin: 'admin',
  member: 'member',
} as const;
